import { wrap_element } from 'js/utils';
 
const height_limit = 165;



export default function product_description_read_more(){
    
    const container = document.querySelector('.product_content_standard p');  
    if( !container ) return; 
    if( container.offsetHeight <= height_limit ) return;
    

    const wrapper = wrap_element(container, 'product_content_standard_wrapper');
    wrapper.style.maxHeight = height_limit + 'px';

    const button = document.createElement('div');
    button.classList.add('product_details_read_more');
    button.textContent = 'read more';
    wrapper.after(button);

    button.addEventListener('click', toggle_height);
    function toggle_height(){
        wrapper.classList.toggle('open');
        const is_open = wrapper.classList.contains('open');
        button.textContent = 'read ' + (is_open ? 'less' : 'more');
        wrapper.style.maxHeight = (is_open ? container.offsetHeight : height_limit) + 'px'; 
    }
}
